import Head from 'next/head';
import dynamic from 'next/dynamic';
import { getBlocksFromQueue } from '~/utils/utils';
import BlockParser from '~/components/blockParser/blockParser';
import PageWrapper from '~/components/wrappers/pageWrapper';

const Utag = dynamic(() => import('~/components/utag/utag'), { ssr: false });

/**
 * Bananamores Feature Page
 * @category Page
 * @extends Component
 * @summary Display the Bananamores page.
 * @return {Node} React node containing the Bananamores page.
 */

const Bananamores = props => {
  const { baseUrl } = props;
  const blockItems = props?.data?.entitySubQueueQuery?.items;
  const title = 'Bananamore\'s Virtual Comedy Club';
  const description = 'Welcome to Bananamore\'s, the internet’s funniest virtual comedy club! Mitzy invites her favorite comedians for stand-up, characters, and storytelling.';
  const path = '/bananamores';
  const hero = blockItems.filter(item => item.field_theme_placement === 'video_hero')[0];

  return (
    <>
      <Head>
        <title>{ title } | The Drew Barrymore Show</title>
        <meta name='title' content={ title }/>
        <link rel='canonical' href={`${ baseUrl }${ path }`} />
        <meta name="twitter:card" content="summary_large_image"/><meta name="twitter:title" content="Bananamore's Virtual Comedy Club"/>
        <meta name='description' content={ description } />
        <meta property="og:url" content={`${ baseUrl }${ path }`} />
        <meta property="og:title" content={ title }/>
        <meta property="og:description" content={ description }/>
        <meta property="og:image" content={ hero.field_image.field_image.logo.url }/>
        <meta property="og:type" content="Article" />
        <link rel="image_src" href={ hero.field_image.field_image.logo.url }/>
        <meta name="twitter:url" content={`${ baseUrl }${ path }`}/>
        <meta name="twitter:image:width" content="1280"/>
        <meta name="twitter:image:height" content="720"/>
        <meta name="twitter:image" content={ hero.field_image.field_image.logo.url }/>
        <meta property="article:published_time"/>
        <meta name="keywords" content="Drew Barrymore Show, virtual comedy club"/>
      </Head>
      { blockItems &&
        <BlockParser blockItems={ blockItems } />
      }
      <Utag pageType='section_door' siteSection='bananamores' />
    </>
  );
}

export async function getStaticProps() {
  // Get Blocks
  const data = await getBlocksFromQueue({
    target_id: 'bananamore_blocks',
    limit: 100
  });

  return {
    props: {
      data
    },
    revalidate: 1
  }
}

export default PageWrapper(Bananamores);
